import { useTranslation } from 'react-i18next'
import * as yup from 'yup'

export const SubcontractorParamsValidationSchema = () => {
  const { t } = useTranslation()

  return yup.object().shape({
    email: yup.string().required(t('milestoneTransfer.errors.email')).email(t('common.errors.emailInvalid')),
    comment: yup.string(),
  })

  // return Yup.object().shape({
  //   name: Yup.string().required(t('objectsPage.errors.name')),
  //   address: Yup.string().required(t('objectsPage.errors.address')),
  //   longitude: Yup.number().required(t('objectsPage.errors.longitude')),
  //   latitude: Yup.number().required(t('objectsPage.errors.latitude')),
  //   category: Yup.string().required(t('objectsPage.errors.category')),
  // })
}
